export default {
  country: "Country",
  addCountry: "AddCountry",
  editCountry: "EditCountry",
};
